import { useNavigate } from "react-router-dom";
import SectionLabel from "@/components/base/SectionLabel";
import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function RelatedServicesSection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel
            label={aiDigitalData.relatedServices.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            {aiDigitalData.relatedServices.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          {aiDigitalData.relatedServices.items.map((item, idx) => (
            <div
              key={idx}
              className="reveal flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center mb-3 md:mb-4">
                <i className={`${item.icon} text-primary-500 text-lg`} />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                {item.desc}
              </p>
              {item.href ? (
                <button
                  onClick={() => navigate(item.href)}
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap self-start"
                >
                  詳しく見る
                  <i className="ri-arrow-right-line" />
                </button>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500 cursor-default whitespace-nowrap self-start">
                  近日公開予定
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}